import { FormArray, FormGroup } from '@angular/forms'

export function takeFormSnapshot(form: FormGroup | FormArray) {
  const initialSnapshot = JSON.stringify(form.getRawValue())

  return function isFormChanged(): boolean {
    const currentSnapshot = JSON.stringify(form.getRawValue())

    return initialSnapshot !== currentSnapshot
  }
}
